import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ahbapi } from '../config/axios/axiosconfig';
import './m1.css';

export default function M1() {
    const [searchParams] = useSearchParams();
    const [offer, setOffer] = useState(null);
    const [voucher, setVoucher] = useState('');
    const TOTAL_TIME = 180; // 3 minutes in seconds
    const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);
    const [error, setError] = useState(false);

    const formatTime = (seconds) => {
        return {
            minutes: Math.floor(seconds / 60),
            remainingSeconds: seconds % 60
        };
    };

    const calculateProgress = (currentTime) => {
        const circumference = 2 * Math.PI * 90; // circle radius is 90 for 200px circle
        const percentage = currentTime / TOTAL_TIME;
        return -1 * (circumference * (1 - percentage)); // Negative for clockwise rotation
    };

    const getOffer = async () => {
        try {
            const offerId = searchParams.get("offerId");
            const res = await ahbapi.get("/m1-api/m1/getoffer", {
                params: { offerId }
            });
            setOffer(res.data);

            const euid = searchParams.get("UID");
            const res2 = await ahbapi.post("/m1-api/m1/getvouchercode", {
                offerId,
                externalUserId: euid || ""
            });
            setVoucher(res2.data.split(" ")[1]);
        } catch (err) {
            console.error(err);
            setError(true);
        }
    };

    useEffect(() => {
        getOffer();
    }, []);

    useEffect(() => {
        if (!offer) return;

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    setError(true);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [offer]);

    if (error) {
        return (
            <div className="container">
                <div className="logo-row">
                    <div className="logo-col">
                        <img src="/images/logos/m1_logo.png" alt="M1" />
                    </div>
                    <div className="logo-col">
                        <img src="/images/logos/mixure_logo.png" alt="" />
                    </div>
                </div>
                <div className="error-container">
                    <div className="error-icon"><img src='/images/icons/alert-triangle.png'></img></div>
                    <h2 className="error-heading">We're Sorry!</h2>
                    <p className="error-message">All our ice cream offers have been scooped up!</p>
                    {/* <button className="btn btn-done">Done</button> */}
                </div>
                <p className="footer-text">
                    Visit M1 cashback page for great saving and rewards
                </p>
            </div>
        );
    }

    const { minutes, remainingSeconds } = formatTime(timeLeft);

    if (voucher.length>0) {


        return (
            <div className="container">
                <div className="logo-row">
                    <div className="logo-col">
                        <img src="/images/logos/m1_logo.png" alt="M1" />
                    </div>
                    <div className="logo-col">
                        <img src="/images/logos/mixure_logo.png" alt="Dunkin" />
                    </div>
                </div>

                <div className="timer-section">
                    <div className="timer-circle">
                        <svg viewBox="0 0 200 200">
                            <g transform="rotate(-90, 100, 100)">
                                <circle
                                    cx="100"
                                    cy="100"
                                    r="90"
                                    className="timer-circle-bg"
                                />
                                <circle
                                    cx="100"
                                    cy="100"
                                    r="90"
                                    className="timer-circle-progress"
                                    strokeDasharray={`${2 * Math.PI * 90}`}
                                    strokeDashoffset={calculateProgress(timeLeft)}
                                />
                            </g>
                        </svg>
                        <span className="timer-number">{timeLeft}</span>
                    </div>

                    <div className="voucher-code">
                        {voucher}
                    </div>
                </div>
                <div className="expiry-text">
                    This promo code expires in 3 minutes (180 seconds)
                </div>


                <p className="footer-text">
                    Visit M1 cashback page for great saving and rewards
                </p>
            </div>
        );
    }
}
